// extracted by mini-css-extract-plugin
export default {"icecreamLogo":"IcecreamLogo_icecreamLogo__HzTMm"};